<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="trash-2-outline"></nb-icon>
        <div class="ml-2" i18n>Deleting DRB Item: {{ item.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div class="deep-delete-spinner" *ngIf="spin">
      <app-spinner></app-spinner>
    </div>
    <form #campaignForm="ngForm" *ngIf="!spin">
      <strong i18n>STAGE ENVIRONMENT</strong>
      <hr />
      <div class="row">
        <div class="col">
          <p style="color: green" *ngIf="affectedCampaignsStage.length === 0" i18n>
            No campaigns are associated with this DRB Item
          </p>
          <div *ngIf="affectedCampaignsStage.length > 0">
            <p style="color: orange" *ngIf="affectedCampaignsStage.length === 1" i18n>
              There is one campaign associated with this DRB Item.
            </p>
            <p style="color: orange" *ngIf="affectedCampaignsStage.length > 1" i18n>
              There are {{ affectedCampaignsStage.length }} campaigns associated with this DRB Item.
            </p>
            <ul *ngFor="let campaign of affectedCampaignsStage; index as i">
              <li>
                <label style="padding-top: 6px">
                  ID: {{ campaign.id }} - <strong>{{ campaign.status }}</strong>
                </label>
                <button nbButton size="medium" ghost status="info" (click)="viewCampaign(campaign.id)">
                  <nb-icon icon="external-link-outline" nbTooltip="Open Selected Content" i18n-nbTooltip></nb-icon>
                </button>
              </li>
            </ul>
          </div>
          <p style="color: green" *ngIf="affectedContentStage.length === 0" i18n>
            No contents are associated with this DRB Item
          </p>
          <div *ngIf="affectedContentStage.length > 0">
            <p style="color: orange" *ngIf="affectedContentStage.length === 1" i18n>
              There is one content associated with this DRB Item
            </p>
            <p style="color: orange" *ngIf="affectedContentStage.length > 1" i18n>
              There are {{ affectedContentStage.length }} contents associated with this DRB Item.
            </p>
            <ul *ngFor="let content of affectedContentStage; index as i">
              <li>
                <label style="padding-top: 6px">ID: {{ content.content_id }} - {{ content.headline_text }}</label>
                <button nbButton size="medium" ghost status="info" (click)="viewContent(content.id)">
                  <nb-icon icon="external-link-outline" nbTooltip="Open Selected Content" i18n-nbTooltip></nb-icon>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <br />

      <strong i18n>PROD ENVIRONMENT</strong>
      <p style="color: red" *ngIf="affectedCampaignsProdIDs.length > 0 || affectedContentProdIDs.length > 0" i18n>
        Associated items in production can't be previewed.
      </p>
      <hr />
      <div class="row">
        <div class="col">
          <p style="color: green" *ngIf="affectedCampaignsProdIDs.length === 0" i18n>
            No campaigns are associated with this DRB Item
          </p>
          <div *ngIf="affectedCampaignsProdIDs.length > 0">
            <p style="color: orange" *ngIf="affectedCampaignsProdIDs.length === 1" i18n>
              There is one campaign associated with this DRB Item.
            </p>
            <p style="color: orange" *ngIf="affectedCampaignsProdIDs.length > 1" i18n>
              There are {{ affectedCampaignsProdIDs.length }} campaigns associated with this DRB Item.
            </p>

            <ul *ngFor="let campaign of affectedCampaignsProdIDs; index as i">
              <li>
                <label style="padding-top: 6px">ID: {{ campaign }}</label>
              </li>
            </ul>
          </div>
          <p style="color: green" *ngIf="affectedContentProdIDs.length === 0" i18n>
            No contents are associated with this DRB Item
          </p>
          <div *ngIf="affectedContentProdIDs.length > 0">
            <p style="color: orange" *ngIf="affectedContentProdIDs.length === 1" i18n>
              There is one content associated with this DRB Item.
            </p>
            <p style="color: orange" *ngIf="affectedContentProdIDs.length > 1" i18n>
              There are {{ affectedContentProdIDs.length }} contents associated with this DRB Item.
            </p>
            <ul *ngFor="let content of affectedContentProdIDs; index as i">
              <li>
                <label style="padding-top: 6px">ID: {{ content }}</label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton class="ml-3" status="danger" [disabled]="deletionEnabled()" (click)="confirmDeletion()" i18n>
        Delete
      </button>
    </div>
  </nb-card-footer>
</nb-card>
